export default function(theme) {
  return {

    actions: {
      padding: `0 ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`
    }

  }
}



// WEBPACK FOOTER //
// ./src/styles/components/EditKeyModal.js